<div class="dialog-terms">
  @if (content$ | async; as content) {
    <span class="title" [innerHTML]="content.title"></span>

    <p class="description" [innerHTML]="content.description"></p>

    <div class="data-container">
      <div class="content-modal" [innerHTML]="content.termsText"></div>
    </div>

    <div *ngIf="!content.hideCheckTerms" class="checkbox-container">
      <input
        type="checkbox"
        id="termsCheckbox"
        data-testid="termsCheckbox"
        class="form-check-input"
        [checked]="acceptTerms$.getValue()"
        (change)="onChangeCheckbox()"
      />
      <label for="termsCheckbox" [innerHTML]="content.checkboxLabel"></label>
    </div>

    <cx-button
      *ngIf="!content.hideCheckTerms"
      (click)="confirmTerm()"
      [disabled]="!acceptTerms$.getValue()"
      [loading]="isLoading$.getValue()"
      >Continuar</cx-button
    >
  }
</div>
